module.exports = __webpack_public_path__ + "media/images/checkmark-15a9e7cdffdd8f778f8d537042573c80.svg";